import { render, staticRenderFns } from "./rating.vue?vue&type=template&id=7092bfdf&"
import script from "./rating.vue?vue&type=script&lang=ts&"
export * from "./rating.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7092bfdf')) {
      api.createRecord('7092bfdf', component.options)
    } else {
      api.reload('7092bfdf', component.options)
    }
    module.hot.accept("./rating.vue?vue&type=template&id=7092bfdf&", function () {
      api.rerender('7092bfdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/rating.vue"
export default component.exports